export interface Ordering {
  field: 'status' | 'reportingPeriod';
  direction: 'asc' | 'desc';
}

const defaultValue: Ordering = {
  field: 'reportingPeriod',
  direction: 'desc'
};

// eslint-disable-next-line no-redeclare
export const Ordering = {
  defaultValue
};
